import ProSelectInput from "../../../../Components/Inputs/SelectField"
import ProTextInput from "../../../../Components/Inputs/TextField";
import FormSectionWrapper from "../../../../Components/ProForms/FormSectionWrapper";

const ProjectSiteInterconnectionInfoSection = ({
  defaultFormProps,
  formConfig,
  permissions,
  interconnectionApproval,
  timeKeeping,
}) => {
  const fieldPermission = key => permissions.fieldPerObj[formConfig[key].perKey];

  const fields = [
    { key: "interconnectingUtility", type: "text" },
    { key: "interconnectionApproval", type: "select", options: interconnectionApproval },
    { key: "interconnectionTiming", type: "text" },
    { key: "interconnectionVoltage", type: "text" },
    { key: "interconnectPoint", type: "text" },
    { key: "interconnectDistance", type: "text" },
    { key: "ROWRequired", type: "select", options: timeKeeping },
    { key: "interconnectQueueStatus", type: "text" },
    { key: "substationCongestion", type: "text" },
    { key: "interconnectionUtilityProcess", type: "text" },
    { key: "interconnectNetworkUpgrades", type: "text" },
    { key: "dataConnectionAvailability", type: "text" },
  ];

  const renderField = ({ key, type, options }) => {
    const config = formConfig[key];
    const permission = fieldPermission(key);
    const commonProps = {
      key,
      ...defaultFormProps,
      ...config,
      permission,
    };

    if (type === "select") {
      return <ProSelectInput {...commonProps} options={options} />;
    }
    return <ProTextInput {...commonProps} />;
  };

  return (
    permissions.canView && (
      <FormSectionWrapper collapsible defaultClose title="Project Site: Interconnection Info">
        {fields.map(renderField)}
      </FormSectionWrapper>
    )
  );
};

export default ProjectSiteInterconnectionInfoSection;
